import GeolocationProvider from './GeolocationProvider';
import OneTrustAPI from '../../../onetrust-api';

/**
 * Represents OneTrustGeolocationProvider
 */
class OneTrustGeolocationProvider extends GeolocationProvider {
	/**
	 * @constructor
	 */
	constructor() {
		super();
  	}

	/**
	 * Returns customer geolocation
	 * @returns {IOneTrustGeolocation}
	 */
	async getGeolocation(): Promise<IOneTrustGeolocation> {
		return await OneTrustAPI.getGeolocation();
	}
}

export interface IOneTrustGeolocation {
	country: string;
	state: string;
	stateName: string;
	continent: string;
}

export default OneTrustGeolocationProvider;